import React from 'react';
import { useDropzone } from 'react-dropzone';
import styled from 'styled-components';

interface Props {
  children: React.ReactNode;
  onDrop: (files: File[]) => void;
}

const StyledDropzone = styled.div`
  height: 100%;
`;

export const Dropzone = ({ children, onDrop }: Props) => {
  const { getRootProps } = useDropzone({
    noClick: true,
    onDrop,
  });

  return <StyledDropzone {...getRootProps()}>{children}</StyledDropzone>;
};
